import { MouseEvent } from "react";
import cls from "classnames";
import styles from "./index.module.scss";
import { ReactComponent as CloseIcon } from "../icons/close.svg";
import DotPulse from "../DotPulse";
import { IGuessItem } from "../../objects/guess/types";

interface IProps {
  loading: boolean;
  list: IGuessItem[];
  mobile?: boolean;
  onClick: (item: string) => void;
}

const Guess = ({ loading, list, onClick, mobile }: IProps) => {
  if (loading)
    return (
      <div className={cls(styles.guessContainer, mobile && styles.mobile)}>
        <div className={styles.loading}>
          <DotPulse width={1} height={1} />
        </div>
      </div>
    );
  if (list.length === 0) return null;
  return (
    <div className={cls(styles.guessContainer, mobile && styles.mobile)}>
      {list.map(item => (
        <div
          key={item}
          data-ti="guess_click"
          data-tn="击猜你想问"
          data-tk0="guess"
          data-tv0={item}
          className={styles.guess}
          onClick={() => onClick(item)}
        >
          {item}
        </div>
      ))}
    </div>
  );
};

export default Guess;
